var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-bg",
    d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color",
    d: "M12.5 25L12 28H28L27.5 26L25 23L16 22.5L12.5 25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "icon-path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 16C23.5 17.933 21.933 19.5 20 19.5C18.067 19.5 16.5 17.933 16.5 16C16.5 14.067 18.067 12.5 20 12.5C21.933 12.5 23.5 14.067 23.5 16ZM25 16C25 18.7614 22.7614 21 20 21C17.2386 21 15 18.7614 15 16C15 13.2386 17.2386 11 20 11C22.7614 11 25 13.2386 25 16ZM18.3354 16.2929C18.726 16.1548 19.1544 16.3595 19.2925 16.7501C19.3958 17.0424 19.6746 17.25 20 17.25C20.3254 17.25 20.6042 17.0424 20.7075 16.7501C20.8455 16.3595 21.274 16.1548 21.6646 16.2929C22.0551 16.4309 22.2598 16.8594 22.1218 17.2499C21.8133 18.1228 20.9808 18.75 20 18.75C19.0192 18.75 18.1867 18.1228 17.8782 17.2499C17.7402 16.8594 17.9449 16.4309 18.3354 16.2929ZM17 22C13.8244 22 11.25 24.5744 11.25 27.75V28.25C11.25 28.6642 11.5858 29 12 29H28C28.4142 29 28.75 28.6642 28.75 28.25V27.75C28.75 24.5744 26.1756 22 23 22H17ZM27.2428 27.5C27.1134 25.2692 25.2633 23.5 23 23.5H17C14.7367 23.5 12.8866 25.2692 12.7572 27.5H27.2428Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccount);
export default __webpack_public_path__ + "static/media/icon-account.7a77f96df00aa1cd0befd5dd2d7309d5.svg";
export { ForwardRef as ReactComponent };